type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const CodInStatus = Object.freeze({
  PENDING: 1 as const,
  WAITING: 2 as const,
  CONFIRM: 3 as const,
});

export type CodInStatus = EnumLiteralsOf<typeof CodInStatus>;
